import React from 'react';
import { TextField, ITextFieldProps } from '@fluentui/react';

interface Props {
    label: string;
    value?: string;
    onChange: (value: string) => void;
    multiline?: boolean;
    rows?: number;
    placeholder?: string;
}

const LabeledTextField: React.FC<Props> = ({ label, value = '', onChange, multiline, rows, placeholder }) => {
    const textFieldProps: ITextFieldProps = {
        label,
        value,
        onChange: (_, newValue) => onChange(newValue || ''),
        multiline,
        rows,
        placeholder
    };

    return <TextField {...textFieldProps} />;
};

export default LabeledTextField;
